import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import DropdownComp from 'components/Dropdown/Dropdown';
import _compact from 'lodash/compact';
import classes from './InCallNotification.module.scss';

export class InCallNotification extends Component {
  constructor(props) {
    super(props);
    this.state = { hideChildren: false };
  }

  errorMessageComp = () => (
    <span className={classes.errorMessage}>
      {this.props.errorMessage}
      {
        (this.props.children) ?
          <i
            className={classes.downArrow}
          /> :
          null
      }
    </span>
  );

  handleMouseEnter = () => {
    this.setState({ hideChildren: false });
  };

  handleMouseLeave = () => {
    this.setState({ hideChildren: true });
  };

  render() {
    const dropdownClassNames = _compact([
      classes.errorDetail,
      this.state.hideChildren ? classes.hiddenDropdown : ''
    ]).join(' ');

    return (
      <div
        className={classes.container}
        onMouseLeave={this.handleMouseLeave}
        onMouseEnter={this.handleMouseEnter}
      >
        {
          (this.props.children) ?
            (
              <div className={classes.errorDetailContainer}>
                <DropdownComp
                  buttonComponent={this.errorMessageComp()}
                  menuComponent={this.props.children}
                  dropdownClassName={dropdownClassNames}
                  menuNoLeft
                />
              </div>
            )
            :
            (
              this.errorMessageComp()
            )
        }
      </div>
    );
  }
}


InCallNotification.propTypes = {
  errorMessage: PT.string,
  children: PT.element
};

export default InCallNotification;
